// @ts-nocheck

import React from 'react';

import { T } from '@/v2/helpers/i18n';

import styles from './header.module.scss';
import { TextStyle } from '@ticketmaster/global-design-system';
import DateAndLocation from '@/v2/header/dateAndLocation.tsx';
import { HEADER_TITLE, HEADER_TITLE_MULTI_EVENT } from '@/v2/header/header.constants.ts';
import { withTranslation } from 'react-i18next';
import { MultiEventEnvelopeModel } from '@/v2/models/multiEventEnvelopeModel.ts';

type Props = {
  envelope: MultiEventEnvelopeModel;
} & T;

const AppHeader = ({ envelope, t }: Props) => {
  if (envelope === null) {
    return (
      <div className={styles.header}>
        <TextStyle.Boising className={styles.eventName}>{t(HEADER_TITLE_MULTI_EVENT)}</TextStyle.Boising>
      </div>
    );
  }

  const eventTickets = envelope.eventTickets;
  if (eventTickets.length > 1) {
    return (
      <div className={styles.header}>
        <TextStyle.Boising className={styles.eventName}>
          {t(HEADER_TITLE_MULTI_EVENT)} ({eventTickets.length})
        </TextStyle.Boising>
      </div>
    );
  }

  const event = eventTickets[0]?.event;
  return (
    <div className={styles.header}>
      <TextStyle.Fiji className={styles.eventName}>{event ? event.title : t(HEADER_TITLE)}</TextStyle.Fiji>
      {event && <DateAndLocation event={event} />}
    </div>
  );
};

export default withTranslation('translation')(AppHeader);
